import { Lesson } from "@packages/store/models/Lesson/LessonModel";

export const sortByDate = (prev: Lesson, next: Lesson) => {
  return Number(prev.startAtLocal) - Number(next.startAtLocal);
};
